// extracted by mini-css-extract-plugin
export default {"container":"_5AnUrtlO3ETEOBbtXWCpgZ"};